"use client";

import { Box, Flex, Heading, Text } from "@chakra-ui/react";

// styles
import {
  institucionalStyles,
  politicaPrivacidadeStyles,
} from "styles/institucionalStyles";

export default function PoliticaPrivacidadePage() {
  return (
    <Box {...politicaPrivacidadeStyles.container}>
      <Flex {...politicaPrivacidadeStyles.mainFlex}>
        <Heading as="h1" size="2xl" {...institucionalStyles.heading}>
          Política de Privacidade AAJUMP
        </Heading>

        <Text {...politicaPrivacidadeStyles.content} whiteSpace="pre-line">
          {`1. Informações Gerais
Esta Política de Privacidade explica como a AAJUMP coleta e usa informações dos usuários que visitam nosso site institucional https://www.aajump.com.br. Ao utilizar nossos serviços, você concorda com a coleta e uso de informações de acordo com esta política.

2. Dados que Coletamos
Podemos coletar dois tipos de informações:

• Dados Pessoais: Nome, e-mail, RG, CPF, data de nascimento, matrícula, regional, lotação, carreira, estado civil, nome do cônjuge, data de nascimento do cônjuge, nome do pai, data de nascimento do pai, nome da mãe, data de nascimento da mãe, telefones, endereço e quantidade de filhos, fornecidos voluntariamente por você.

• Dados de Navegação: Endereço IP, tipo de navegador, páginas visitadas e tempo de permanência, coletados automaticamente via cookies.

3. Finalidade do Tratamento de Dados
Utilizamos os dados para:
• Responder dúvidas e solicitações.
• Enviar comunicações institucionais ou marketing (mediante consentimento).
• Melhorar a experiência de navegação.
• Validação de acesso a reuniões e ao portal.

4. Compartilhamento de Dados
Não vendemos nem alugamos seus dados pessoais. O compartilhamento ocorre apenas para:
• Cumprimento de obrigações legais ou ordens judiciais.
• Provedores de tecnologia que sigam a LGPD.

5. Seus Direitos (LGPD)
Você tem o direito de:
1. Confirmar a existência do tratamento.
2. Acessar, corrigir ou excluir dados.
3. Revogar consentimentos.

6. Uso de Cookies
Utilizamos cookies para entender sua navegação. Você pode desativá-los no navegador, ciente de possíveis limitações.

7. Segurança
Adotamos medidas técnicas e administrativas para proteger seus dados.

8. Contato
Encarregado de Dados (DPO)
• E-mail: contato@aajump.com.br
• Endereço: Rua Riachuelo, 96, cj. 701 – Sé – São Paulo/SP – CEP 01007-000`}
        </Text>
      </Flex>
    </Box>
  );
}
